<template>
  <div class="items-start flex mr-4" v-if="categories.length">
    <div class="dropdown">
      <button
        data-toggle="dropdown"
        class="space-x-3 text-blackest rounded-full bg-grey-lighter py-4 px-4 focus:outline-hidden"
      >
        <span class="font-bold">{{ selectedCategory }}</span>
        <span class="caret" />
      </button>
      <ul class="dropdown-menu">
        <li
          v-for="category in categories"
          :key="category.value"
          @click="select(category.value)"
          class="px-4 py-1 cursor-pointer hover:bg-primary hover:text-white"
        >
          {{ category.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  name: "PrizeCategorySelector",
  props: {
    categories: Array,
  },
  methods: {
    select(category) {
      if (category != "all") this.setFilter({ filterType: "competition_category_ids", filter: [category] })
      else this.clearFilter("competition_category_ids")
    },
    ...mapActions("filter", ["setFilter", "clearFilter"]),
  },
  computed: {
    selectedCategory() {
      return this.categories.find((category) => category.value == this.prize_category).title
    },
    ...mapState("filter", {
      prize_category: ({ filters }) => filters.competition_category_ids[0] || "all",
    }),
  },
}
</script>
